(function (angular) {
    'use strict';

    var EventMapper = (function () {
        function EventMapper() { }
        EventMapper.prototype.initialise = function (_eventMapper) {
            this._eventMapper = _eventMapper;
        }
        EventMapper.prototype.conversationDeleted = function (event) {
            return {
                conversationId: event.chatId,
                createdBy: event.context.createdBy,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.conversationUndeleted = function (event) {
            return {
                conversationId: event.chatId,
                createdBy: event.context.createdBy,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.conversationUpdated = function (event) {
            return {
                conversationId: event.chatId,
                // the user who updated the conversation
                createdBy: event.context.createdBy,
                description: event.payload.description,
                eTag: event.etag,
                isPublic: event.payload.isPublic,
                name: event.payload.name,
                roles: event.payload.roles,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.participantAdded = function (event) {
            return {
                channelId: event.payload.channelId,
                conversationId: event.chatId,
                createdBy: event.context.createdBy,
                profileId: event.payload.profileId,
                role: event.payload.role,
                chatStatus: event.payload.chatStatus,
                teamId: event.payload.teamId,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.participantRemoved = function (event) {
            return {
                conversationId: event.chatId,
                createdBy: event.context.createdBy,
                profileId: event.payload.profileId,
                role: event.payload.role,
                chatStatus: event.payload.chatStatus,
                teamId: event.payload.teamId,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.participantTyping = function (event) {
            return {
                conversationId: event.payload.chatId,
                createdBy: event.context.createdBy,
                profileId: event.payload.profileId,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.participantTypingOff = function (event) {
            return {
                conversationId: event.payload.chatId,
                createdBy: event.context.createdBy,
                profileId: event.payload.profileId,
                timestamp: event.publishedOn,
            };
        };
        EventMapper.prototype.conversationMessageSent = function (event) {
            return {
                conversationEventId: event.chatEventId,
                conversationId: event.payload.context.chatId,
                eventId: event.eventId,
                name: "conversationMessage.sent",
                payload: {
                    alert: event.payload.alert,
                    context: event.payload.context,
                    messageId: event.payload.messageId,
                    metadata: event.payload.metadata,
                    parts: event.payload.parts,
                }
            };
        };
        EventMapper.prototype.conversationMessageRead = function (event) {
            return {
                conversationEventId: event.chatEventId,
                conversationId: event.payload.chatId,
                eventId: event.eventId,
                name: "conversationMessage.read",
                payload: {
                    conversationId: event.payload.chatId,
                    messageId: event.payload.messageId,
                    profileId: event.payload.profileId,
                    timestamp: event.payload.timestamp
                }
            };
        };
        EventMapper.prototype.conversationMessageDelivered = function (event) {
            return {
                conversationEventId: event.chatEventId,
                conversationId: event.payload.chatId,
                eventId: event.eventId,
                name: "conversationMessage.delivered",
                payload: {
                    conversationId: event.payload.chatId,
                    messageId: event.payload.messageId,
                    profileId: event.payload.profileId,
                    timestamp: event.payload.timestamp
                }
            };
        };
        EventMapper.prototype.profileUpdated = function (event) {
            return this._eventMapper.profileUpdated(event);
        };
        return EventMapper;
    }());

    angular.module('shared')
        .service('EventMapper', EventMapper);

})(window.angular);
